import {style} from 'typestyle'
import * as csstips from 'csstips'

export const HomeMenu = style({
    ...csstips.flexRoot,
    width: '100%',
    ...csstips.centerJustified,
    ...csstips.center,
    textAlign: 'center',
    paddingBottom: 15,
    marginTop: 13,
    paddingLeft: 15,
    paddingRight: 15
})

export const HomeMenuItem = style({
    position: 'relative',
    ...csstips.flex1,
    $nest: {
        '&:active': {
            opacity: 0.7
        },
        '& .HomeMenuItemIconActive': {
            $nest: {
                '&:active': {
                    opacity: 0.7
                }
            }

        }
    }
})

export const HomeMenuItemIcon = style({
    width: 44
})

export const HomeMenuItemText = style({
    fontSize: 12,
    color: '#666666',
    letterSpacing: 0,
    textAlign: 'center',
    lineHeight: '18px',
    marginTop: 3
})

export const HomeMenuItemIconWrap = style({
    display: 'inline-block',
    lineHeight: 0,
    position: 'relative',
    $nest: {
        '&:active': {
            opacity: 0.7
        }
    }
})

export const HomeMenuItemIconTopTips = style({
    background: '#ff2e3e',
    fontSize: 10,
    display: 'inline-block',
    lineHeight: '12px',
    color: '#fff',
    padding: 2,
    borderTopLeftRadius: 7,
    borderTopRightRadius: 7,
    borderBottomRightRadius: 7,
    border: '2px solid #fff',
    whiteSpace: 'nowrap'
})

export const HomeMenuItemIconContent = style({
    position: 'absolute',
    width: '100%',
    top: -5
})



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeMenu/HomeMenu.style.ts